<div class="file-drop-container">
  <form class="file-drop" enctype="multipart/form-data">
    <input id="file" name="files[]" type="file" accept=".gpx" (change)="onFileSelected($event)" />
    <div class="file-drop-input">
      <div
        class="file-drop-target"
        (drop)="onFileDropped($event)"
        (dragenter)="onFileDragEnter()"
        (dragleave)="onFileDragLeave()"
      ></div>
      <div class="instructions">
        @if (!isDragOver) {
          @if (errorMessage) {
            <div class="import-error-message">
              {{ errorMessage }}
            </div>
          }
          @if (errorMessageDetail) {
            <div class="import-error-message">
              {{ errorMessageDetail }}
            </div>
          }
          <p class="helper-bold" i18n>Drag a GPX file here, or click the upload button to get started.</p>
          <p class="helper-secondary-text" i18n>
            GPX is a universal format used by GPS devices to transfer geographic information. You can import rides from
            your friends or a GPS device.
          </p>
        } @else {
          <p class="helper-bold" i18n>Drop your file to import.</p>
        }
      </div>
    </div>
    <div class="file-drop-buttons-container">
      <div class="file-drop-buttons">
        <button id="cancelFileDrop" class="button secondary-button" type="button" (click)="onCancel()" i18n>
          Cancel
        </button>
        <label id="uploadFileDrop" class="button primary-button" for="file">
          <span i18n>Upload</span>
        </label>
      </div>
    </div>
  </form>
</div>
